// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"Modal_clearfix__2jnrg","ellipsis":"Modal_ellipsis__2i65M","hide":"Modal_hide__1-bbZ"};